import { Button } from "components/Button/Button";
import { Input, Select } from "components/Form";
import useFullPageLoader from "hooks/useFullPageLoader";
import useMuiButtonLoader from "hooks/useMuiButtonLoader";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  getDharmikSankalpanaListById,
  updateDharmikSankalpana,
} from "services/dharmiksankalpana";

export default function UpdateDharmikSankalpana() {
  const { id } = useParams();
  const [data, setData] = useState({});
  const [errorField, setErrorField] = useState({});

  const navigate = useNavigate();
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [submitButtonElement, setSubmitLoading] = useMuiButtonLoader();

  // ************************************** Fetch Records **********************************************
  const fetchRecord = async () => {
    showLoader();
    try {
      const res = await getDharmikSankalpanaListById({
        id: id,
      });
      hideLoader();
      if (res.code === 200) {
        const { id, Name, Mobile, RequestFor, StayingPlace, AddedOn } =
          res.data.DharmikSankalpanaList;
        setData({
          ...data,
          name: Name,
          mobile: Mobile,
          stayingOptions: StayingPlace,
          requestFor: RequestFor,
        });
      } else {
        toast.error(res.message);
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || err.message);
    }
    hideLoader();
  };
  useEffect(() => {
    fetchRecord();
  }, []);

  //*********************Handel Validation********************************** */
  const handleValidation = () => {
    let errorField = {};
    let formIsValid = true;
    if (!data.name) {
      errorField["name"] = "Please Enter Name";
      formIsValid = false;
    }
    if (!data.mobile) {
      errorField["mobile"] = "Please Enter Mobile";
      formIsValid = false;
    } else if (data.mobile.length !== 10) {
      errorField["mobiles"] = "Mobile number must be 10 digits";
      formIsValid = false;
    }
    if (!data.requestFor) {
      errorField["requestFor"] = "Please Enter Request For";
      formIsValid = false;
    }
    if (!data.stayingOptions) {
      errorField["stayingOptions"] = "Please Enter Staying Option";
      formIsValid = false;
    }

    setErrorField(errorField);
    return formIsValid;
  };
  //*********************Submit Sankalpana Handler********************************** *//
  const submitSankalpana = async (e) => {
    e.preventDefault();
    if (handleValidation()) {
      setSubmitLoading(true);
      try {
        const res = await updateDharmikSankalpana({
          id: id,
          Name: data.name,
          Mobile: data.mobile,
          RequestFor: data.requestFor,
          StayingPlace: data.stayingOptions,
        });
        if (res.code === 200) {
          toast.success(res.message);
          setSubmitLoading(false);
          navigate(-1);
        } else {
          toast.error(res.message);
          setSubmitLoading(false);
        }
      } catch (err) {
        toast.error(err?.response?.data?.message || err.message);
        setSubmitLoading(false);
      }
    } else {
      toast.error("Please fill all the fields");
    }
  };

  return (
    <>
      <div className="">
        <div className="WrapperBox">
          <div className="Small-Wrapper">
            <div className="search_wrap">
              <div className="search_wrap"></div>
              <h4 className="Title">
                <Link to={-1}>
                  <i className="fa fa-arrow-left"></i>
                </Link>
                Update Dharmik Sankalpana
              </h4>
            </div>

            <div className="row mt-1">
              <div className="col-12 col-sm-12 col-md-12 col-lg-11 col-xl-11 mx-auto">
                <form onSubmit={submitSankalpana}>
                  <div className="form-group row mt-1">
                    <div className="col-md-12 col-form-label order-1 d-flex flex-column justify-content-end">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="row">
                            <div className="col-sm-6 col-form-label">
                              <Input
                                type="text"
                                name="name"
                                value={data.name}
                                onChange={(e) => {
                                  const { value, name } = e.target;
                                  setData({
                                    ...data,
                                    [name]: value,
                                  });
                                }}
                                placeholder="Enter  Name"
                                className={`form-control `}
                                maxLength={50}
                                label="Name"
                                error={errorField.name}
                                required
                              />
                            </div>
                            <div className="col-sm-6 col-form-label">
                              <Input
                                type="text"
                                name="mobile"
                                value={data.mobile}
                                onChange={(e) => {
                                  const { value, name } = e.target;
                                  setData({
                                    ...data,
                                    [name]: value.replace(/\D/g, ""),
                                  });
                                }}
                                placeholder="Enter Mobile"
                                className={`form-control `}
                                maxLength={10}
                                label="Mobile"
                                error={errorField.mobile}
                                required
                              />
                              {errorField.mobiles && (
                                <span
                                  className="error"
                                  style={{
                                    color: "#dc3545",
                                    fontSize: "13px",
                                    marginLeft: "1px",
                                  }}
                                >
                                  {errorField.mobiles}
                                </span>
                              )}
                            </div>
                            <div className="col-sm-6  col-form-label">
                              <Select
                                name={`requestFor`}
                                placeholder={`Select Request For`}
                                //   onChange={(e) => {
                                //     const { name, value } = e.target;
                                //     setData({ ...data, [name]: value });
                                //   }}
                                onChange={(e) => {
                                  const { name, value } = e.target;
                                  setData({ ...data, [name]: value });
                                }}
                                //   value={data.item[i]}
                                value={data.requestFor}
                                className={`form-control `}
                                label={`Request For`}
                                error={errorField.requestFor}
                                required
                              >
                                <option value="">Select Request For</option>
                                {["दत्तयाग", "गुरु चरित्र पारायण"].map(
                                  (data) => {
                                    return (
                                      <option value={data} key={data}>
                                        {data}
                                      </option>
                                    );
                                  }
                                )}
                              </Select>
                            </div>
                            <div className="col-sm-6  col-form-label">
                              <Select
                                name={`stayingOptions`}
                                placeholder={`Select Staying Options`}
                                //   onChange={(e) => {
                                //     const { name, value } = e.target;
                                //     setData({ ...data, [name]: value });
                                //   }}
                                onChange={(e) => {
                                  const { name, value } = e.target;
                                  setData({ ...data, [name]: value });
                                }}
                                //   value={data.item[i]}
                                value={data.stayingOptions}
                                className={`form-control `}
                                label={`Staying Option`}
                                error={errorField.stayingOptions}
                                required
                              >
                                <option value="">Select Staying Option</option>
                                {["मंदिर मुक्काम", "बहेरगाव मुक्कम"].map(
                                  (data) => {
                                    return (
                                      <option value={data} key={data}>
                                        {data}
                                      </option>
                                    );
                                  }
                                )}
                              </Select>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="text-center mt-4">
                    <Button
                      to={-1}
                      // {...submitButtonElement}
                      style={{ marginRight: "5px" }}
                    >
                      Cancel
                    </Button>
                    <Button
                      type="submit"
                      // {...submitButtonElement}
                    >
                      {/* Add Customer */}
                      Submit
                    </Button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
